import { AccountStatus, formatAccountStatus } from '../constants/account';

const statusClass: Record<string, string> = {
  [AccountStatus.Allowed]: 'bg-green-100 text-green-700',
  [AccountStatus.Blocked]: 'bg-red-100 text-red-700',
};

export const AccountStatusBadge = ({ status, remarks }: { status: string; remarks?: string | null }) => (
  <span
    title={remarks ?? undefined}
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${statusClass[status?.toLowerCase()] ?? 'bg-gray-100 text-gray-600'}`}
  >
    {formatAccountStatus(status)}
  </span>
);
